import React, {createContext, useContext, ReactNode} from 'react'

type ProductSortingEngine = 'salesforce' | 'dynamic_yield'

export interface ProductTileAnalyticsState {
    productSortingEngine?: ProductSortingEngine
    productSortingType?: string
}

const ProductTileAnalyticsContext = createContext<ProductTileAnalyticsState | undefined>(undefined)

export const ProductTileAnalyticsProvider = ({children, value}: {children: ReactNode; value: ProductTileAnalyticsState}) => {
    return <ProductTileAnalyticsContext.Provider value={value}>{children}</ProductTileAnalyticsContext.Provider>
}

export const useProductTileAnalyticsContext = () => {
    return useContext(ProductTileAnalyticsContext)
}
